import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  loaderOverlay: {
    zIndex: 1,
  },
}));

export default useStyles;
